export * from './abteilung-post-request.interface';
export * from './abteilung-post-response.interface';
export * from './abteilung-post.shapes';
